import { NgModule } from '@angular/core';

import { CmpsScorecardCategoryComponent } from './scorecard-category.component';

@NgModule({
    declarations: [CmpsScorecardCategoryComponent],
    exports: [CmpsScorecardCategoryComponent],
})
export class CmpsScorecardCategoryModule {}
